import * as React from 'react'
import { BLUE } from '../../colors'

const IconShare = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g fill={props.color ?? BLUE} fillRule='evenodd'>
      <path d='M19.5 8.121H17a1.5 1.5 0 1 0 0 3h1v9H7v-9h1a1.5 1.5 0 1 0 0-3H5.5a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h14a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5' />
      <path d='m10.683 6.287.317-.3v7.624a1.5 1.5 0 1 0 3 0V5.986l.318.301a1.496 1.496 0 0 0 2.12-.057 1.5 1.5 0 0 0-.057-2.121l-2.85-2.698a1.5 1.5 0 0 0-2.062 0l-2.85 2.698a1.5 1.5 0 0 0 2.064 2.178' />
    </g>
  </svg>
)

export default IconShare
